import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function formatTime(seconds: number): string {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hrs > 0) {
        return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function getZoneColor(zone: string): string {
    const colors: Record<string, string> = {
        Z1: 'bg-gray-400',
        Z2: 'bg-blue-500',
        Z3: 'bg-green-500',
        Z4: 'bg-yellow-500',
        Z5: 'bg-orange-500',
        Z6: 'bg-red-500',
        Z7: 'bg-purple-600'
    };
    return colors[zone] || 'bg-gray-400';
}
